import elm from './elm';

import sceneAbc from './scenes/abc';
import scene123 from './scenes/123';

import './keyboard';

elm.domReady(init);

function init() {
  scene123();
  sceneAbc();
}



// WEBPACK FOOTER //
// ./src/js/index.js